import gql from "graphql-tag";

export const ME_QUERY = gql`
    query me {
        me {
            _id
            company
            clientIds
            clients {
                name
            }
            status
            description
            bidExpiration
            personalNumber
            name
            email
            phoneNumber
            roleIds
            roles {
                _id
                status
                name
                permissionType
            }
            noteIds
            notes {
                _id
            }
            termsOfService {
                _id
            }
            frontendRoleId
            frontendRole {
                _id
            }
            lastLoginTimestamp
            lastBankIdLoginTimestamp
            lastPasswordUpdate
            updateTimestamp
            createTimestamp
            unreadTicketsCount
        }
    }
`;

export const CLIENTS_BY_ASSETS_QUERY = gql`
    query clientsByAssets {
        clientsByAssets {
            asset
            clients {
                _id
                name
            }
        }
    }
`;

export const USERS_QUERY = gql`
    query users {
        users {
            _id
            name
            clientIds
            clients {
                _id
                name
            }
            description
            bidExpiration
            personalNumber
            email
            phoneNumber
            roleIds
            roles {
                _id
                name
            }
            noteIds
            notes {
                _id
            }
            password
            status
            frontendRoleId
            frontendRole {
                _id
                name
            }
            termsOfService {
                _id
            }
            lastPasswordUpdate
        }
    }
`;

export const USER_QUERY = gql`
    query user($_id: GraphQLObjectId, $personalNumber: String) {
        user(_id: $_id, personalNumber: $personalNumber) {
            _id
            name
            description
            bidExpiration
            personalNumber
            email
            phoneNumber
            roleIds
            noteIds
            password
            status
            frontendRoleId
        }
    }
`;

export const UPDATE_USER = gql`
    mutation updateUser($input: UpdateUserInput!) {
        updateUser(input: $input) {
            _id
            name
            clientIds
            clients {
                _id
                name
            }
            description
            bidExpiration
            personalNumber
            email
            phoneNumber
            roleIds
            noteIds
            password
            status
            frontendRoleId
        }
    }
`;

export const CREATE_USER = gql`
    mutation createUser($input: CreateUserInput!) {
        createUser(input: $input) {
            _id
            name
            clientIds
            clients {
                _id
                name
            }
            company
            description
            bidExpiration
            personalNumber
            email
            phoneNumber
            roleIds
            noteIds
            password
            status
            frontendRoleId
        }
    }
`;

export const CHANGE_PASSWORD = gql`
    mutation changePassword($input: ChangePasswordInput!) {
        changePassword(input: $input) {
            personalNumber
            name
            company
            description
            _id
        }
    }
`;

export const ADMIN_GET_ME = gql`
    query getMe {
        me {
            _id
            personalNumber
            roles {
                _id
                assets
                clientIds
                permissionType
                name
            }
        }
    }
`;

export const ADMIN_GET_USERS = gql`
    query getUsers {
        users {
            _id
            clientIds
            clients {
                _id
                name
            }
            status
            personalNumber
            name
            company
            frontendRoleId
            frontendRole {
                _id
                name
            }
            email
            description
            phoneNumber
            lastLoginTimestamp
            lastBankIdLoginTimestamp
            lastPasswordUpdate
            roleIds
            roles {
                _id
                name
                assets
                permissionType
                updateTimestamp
                roleType
                clientIds
                clients {
                    name
                }
            }
            updateTimestamp
            updateUserInfo {
                name
            }
        }

        roles {
            _id
            name
        }
    }
`;

export const ACCEPT_TERMS = gql`
    mutation acceptTerms($input: AcceptTermsInput!) {
        acceptTerms(input: $input) {
            _id
            noteIds
        }
    }
`;
